module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/twitter-2011193c46e0f340d056a377b7d9b954.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/twitter.svg
// module id = PJNl
// module chunks = 24